const FileUploadingStatus = {
  uploading: "uploading",
  done: "done",
  removed: "removed",
};

export default FileUploadingStatus;
